var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"change_tip flex align_items_c"},[_vm._m(0),_c('div',{staticClass:"up_level_btn pointer",on:{"click":function($event){_vm.$parent.$parent.showStatus = 5}}},[_vm._v("立即升级")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"flex align_items_c"},[_c('span',{staticClass:"change_tip_text"},[_vm._v("💡手机号登录? 升级邮箱登录更方便!")])])
}]

export { render, staticRenderFns }